export default "__VITE_ASSET__BJUNy3Wh__"